'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoRepoClone = function GoRepoClone(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm12.5 15h-2.5v2.5h2.5v-2.5z m-5-12.5h10v-2.5h-15s-2.5 1.3-2.5 2.5v30s1.3 2.5 2.5 2.5h5v5l3.8-3.7 3.7 3.7v-5h12.5s2.5-1.2 2.5-2.5v-7.5h-22.5v-22.5z m20 25v3.8s-0.5 1.2-1.2 1.2h-11.3v-2.5h-7.5v2.5h-3.7s-1.3-0.6-1.3-1.2v-3.8h25z m-15-17.5h-2.5v2.5h2.5v-2.5z m-2.5 12.5h2.5v-2.5h-2.5v2.5z m27.5-22.5h-12.5s-2.5 1.3-2.5 2.5v15s1.3 2.5 2.5 2.5h2.5v2.5l1.3-1.2 1.2 1.2v-2.5h7.5s2.5-1.2 2.5-2.5v-15s-1.2-2.5-2.5-2.5z m-10 17.5h-1.2s-1.3-0.6-1.3-1.2v-1.3h2.5v2.5z m10-1.2c0 0.6-0.6 1.2-1.2 1.2h-6.3v-2.5h7.5v1.3z m0-3.8h-10v-10h8.8s1.2 0 1.2 1.3v8.7z m-25-7.5h-2.5v2.5h2.5v-2.5z' })
        )
    );
};

exports.default = GoRepoClone;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/repo-clone.js
// module id = 2244
// module chunks = 168707334958949